import { DataBean } from "../DataBean";

export class UptoEmployee extends DataBean {



    public async updateUptoDateEmployeeContracts(idEmployee: any, media: any, mediaContext: any): Promise<any> {
        return this.getCustomService("CacheOptions", "void_updateUptoDateEmployeeContracts_Number_String_String", [idEmployee, media, mediaContext]);
    }

}
